import {
  GET_ROLE,
  SET_ROLE,
  CREATE_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  GET_MODULES,
  SET_MODULES,
  GET_ROLE_MODULES,
  RoleMasterActionTypes,
} from "types/actions/roleMaster.action";

import { RoleData, ModuleData, RoleModuleData } from "types/models/roleMaster/RoleMasterApp";

const initialState: {
  currentRole: RoleData | null;
  role: RoleData[];
  roleCount: number;
  modules: ModuleData[];
  moduleCount: number;
  roleModules: {
    data: RoleModuleData[];
    total: number;
  };
} = {
  currentRole: null,
  role: [],
  roleCount: 0,
  modules: [],
  moduleCount: 0,
  roleModules: { data: [], total: 0 },
};

const RoleMaster = (state = initialState, action: RoleMasterActionTypes) => {
  switch (action.type) {
    case GET_ROLE:
      return {
        ...state,
        role: action.payload.data,
        roleCount: action.payload.total,
      };
    case SET_ROLE:
      return {
        ...state,
        currentRole: action.payload,
      };
    case CREATE_ROLE:
      return {
        ...state,
        role: [...state.role, action.payload],
        roleCount: state.roleCount + 1,
      };
    case UPDATE_ROLE:
      return {
        ...state,
        role: state.role.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
      };
    case DELETE_ROLE:
      return {
        ...state,
        role: state.role.filter((item) => item.id !== action.payload.id),
        roleCount: state.roleCount - 1,
      };
    case GET_MODULES:
      return {
        ...state,
        modules: action.payload.data,
        moduleCount: action.payload.total,
      };
    case GET_ROLE_MODULES:
  return {
    ...state,
    roleModules: action.payload,   
  };

    default:
      return state;
  }
};

export default RoleMaster;